<template>
  <div
    ref="scrollWrapper"
    class="modalInnerWrapper"
    :class="{ 'new-year': store.isNewYearTheme, 'hide-scroll': hideScroll }"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
const store = useMainStore();
const scrollWrapper = ref<HTMLElement | null>(null);
const showSeasonModal = inject<Ref<boolean>>('showSeasonModal', ref(false));
defineProps<{
  hideScroll?: boolean;
}>();
useResetScroll(showSeasonModal, scrollWrapper);
</script>

<style lang="scss" scoped>
.modalInnerWrapper {
  z-index: 2;
  border-radius: 10px;
  border: 1px solid #1e353e;
  background: radial-gradient(rgba(4, 15, 20, 0.4), rgba(8, 27, 37, 0.4));
  backdrop-filter: blur(2px);
  width: 100%;
  overflow: auto;
  filter: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.7));
  max-height: 50dvh;
  position: relative;

  &.hide-scroll {
    overflow: hidden;
  }
}

.modalInnerWrapper.new-year {
  border: 1px solid #1e353e78;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  display: block;
  left: 0;
  top: 0;
}
</style>
